import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FeeItemType, PermitFeeItem, PermitTicketItem, TicketComment, TicketItemType } from '../../modules/clientModule/types';
import { WikiJurisdictionType } from '../../api/jurisdiction';

export type ClientDataType = {
  label: string;
  value: string;
  email: string;
  companyName: string;
  clientType?: number;
  userRole?: number;
};
export interface WikiKeysState {
  showClientSearchResults: boolean;
  isLoadingKeyClients: boolean;
  selectedClient: ClientDataType;
  isEditing: boolean;
  showConfirmDelete: boolean;
  keyLogin: string;
  keyValue: string;
  website: string;
  keyId: string;
  showValidation: boolean;
}

const initialState: WikiKeysState = {
  showClientSearchResults: false,
  isLoadingKeyClients: false,
  selectedClient: { label: '', value: '', email: '', companyName: '' },
  isEditing: false,
  showConfirmDelete: false,
  keyLogin: '',
  keyValue: '',
  website: '',
  keyId: '',
  showValidation: false,
};

export const wikiKeysSlice = createSlice({
  name: 'wikiKeys',
  initialState,
  reducers: {
    setShowClientSearchResults: (state, action: PayloadAction<boolean>) => {
      state.showClientSearchResults = action.payload;
    },
    setIsLoadingKeyClients: (state, action: PayloadAction<boolean>) => {
      state.isLoadingKeyClients = action.payload;
    },
    setSelectedClient: (state, action: PayloadAction<ClientDataType>) => {
      state.selectedClient = action.payload;
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    },
    setShowConfirmDelete: (state, action: PayloadAction<boolean>) => {
      state.showConfirmDelete = action.payload;
    },
    setKeyLogin: (state, action: PayloadAction<string>) => {
      state.keyLogin = action.payload;
    },
    setKeyValue: (state, action: PayloadAction<string>) => {
      state.keyValue = action.payload;
    },
    setWebsite: (state, action: PayloadAction<string>) => {
      state.website = action.payload;
    },
    setKeyId: (state, action: PayloadAction<string>) => {
      state.keyId = action.payload;
    },
    setShowValidation: (state, action: PayloadAction<boolean>) => {
      state.showValidation = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setKeyLogin,
  setKeyValue,
  setWebsite,
  setKeyId,
  setShowConfirmDelete,
  setIsEditing,
  setIsLoadingKeyClients,
  setShowClientSearchResults,
  setSelectedClient,
  setShowValidation,
} = wikiKeysSlice.actions;

export default wikiKeysSlice.reducer;
